import { render, staticRenderFns } from "./AdminData.vue?vue&type=template&id=4993be02&scoped=true"
import script from "./AdminData.vue?vue&type=script&lang=js"
export * from "./AdminData.vue?vue&type=script&lang=js"
import style0 from "./AdminData.vue?vue&type=style&index=0&id=4993be02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4993be02",
  null
  
)

export default component.exports